import { useInstance } from '@meraki-internal/react-dependency-injection';
import { IThemeColor } from '../theme/IThemeColor';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { IResource } from './IResource';
import { EnvConfiguration } from '../config/EnvConfiguration';
import { SharePageButton } from '../share-caremap/SharePageButton';

export interface IShareResourceButtonProps {
    'data-type': string;
    resource: IResource;
    trackingFrom: 'List' | 'Details' | 'Header',
    buttonLabel?: string;
    color?: IThemeColor;
    iconColor?: IThemeColor;
    mode?: 'ios',
    shape?: 'round',
    size?: 'small';
}

export const ShareResourceButton: React.FC<IShareResourceButtonProps> = ({
    'data-type': dataType,
    resource,
    trackingFrom,
    buttonLabel,
    color,
    iconColor,
    mode,
    shape,
    size,
}) => {
    const config = useInstance(EnvConfiguration);

    const mixpanel = useInstance(MixPanelEventEmitter);

    const pageUrl = `${config.WEB_BASE_URL}/#/resources/${resource.slug}`;

    const onMobileSharingOpened = () => {
        mixpanel.track('Resource Mobile Sharing Opened', () => ({
            'Name': resource.name,
            'Category': resource.category,
            'Link URL': pageUrl,
            'Opened From': trackingFrom
        }));
    };

    const onLinkCopied = () => {
        mixpanel.track('Resource Share Link Copied', () => ({
            'Name': resource.name,
            'Category': resource.category,
            'Link URL': pageUrl,
            'Opened From': trackingFrom
        }));
    };

    return (
        <SharePageButton
            data-type={dataType}
            pageUrl={pageUrl}
            shareSubject="Have you seen this Community Resource in Innerhive?"
            shareBody={`Check out ${resource.name} in Innerhive's Community Resources.`}
            buttonLabel={buttonLabel}
            color={color}
            iconColor={iconColor}
            mode={mode}
            shape={shape}
            size={size}
            onMobileSharingOpened={onMobileSharingOpened}
            onLinkCopied={onLinkCopied}
        />
    );
};
